import React, { createContext } from 'react';
import Cookies from 'js-cookie';

interface ICampaignContext {
  getRecentCampaignId: () => string|null;
  clearRecentCampaign: () => void;
}

const useQuery = () => {
  if(!window?.location?.search) {
    return new URLSearchParams();
  }

  return React.useMemo(() => new URLSearchParams( window.location.search ), [window.location.search]);
};


export const CampaignContext = createContext<Partial<ICampaignContext>>({});

export const CampaignContextProvider = ({ children }):JSX.Element => {
  const query = useQuery();

  if(query.has('utm_source')) {
    Cookies.set('recent_campaign', query.toString());
  }

  const getRecentCampaignId = ():string|null => {
    const cookieVal = Cookies.get('recent_campaign');
    if(!cookieVal) {
      return null;
    }
    const campaign = new URLSearchParams(cookieVal);
    return `${campaign.get('utm_source')}||${campaign.get('utm_term')}`;
  };

  const clearRecentCampaign = ():void => {
    if(!Cookies.get('recent_campaign')) {
      return;
    }
    Cookies.remove('recent_campaign');
  };

  return (
    <CampaignContext.Provider value={{
      getRecentCampaignId,
      clearRecentCampaign,
    }}>
      {children}
    </CampaignContext.Provider>
  );
};
